import store from '@/store';
const showLoading = function(context: any, opt?: any) {
    store.commit('showLoading', opt);
};
const hideLoading = function(context: any) {
    store.commit('hideLoading');
};

export default {
    showLoading,
    hideLoading
};
